/**
 * @generated SignedSource<<1045535266810157dd79e4df2b424f73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportConfirmedEventsAttendanceRateStatisticCardFragment$data = {
  readonly confirmedEventsAttendanceRateReport: {
    readonly allTime: number;
  };
  readonly " $fragmentType": "MemberReportConfirmedEventsAttendanceRateStatisticCardFragment";
};
export type MemberReportConfirmedEventsAttendanceRateStatisticCardFragment$key = {
  readonly " $data"?: MemberReportConfirmedEventsAttendanceRateStatisticCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportConfirmedEventsAttendanceRateStatisticCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportConfirmedEventsAttendanceRateStatisticCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "confirmedEventsAttendanceRateReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "e89aca63e26314dc105b78631a17bcd0";

export default node;
